export default __webpack_public_path__ + "static/corridorqamcom-845aea01d815a611f38d3a996d436d2a.gif";